// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fileUploaderItem__fileName{align-items:center;background-color:hsla(219,9%,70%,.2);color:#171933;display:flex;font-size:1.1rem;font-weight:700;height:3rem;justify-content:center;line-height:1.4rem;padding:.7rem 1rem;white-space:nowrap}.fileUploaderItem__fileName--asUrl{cursor:pointer}.fileUploaderItem__fileIcon{color:#abb0b9;font-size:2rem;margin-right:1rem}.fileUploaderItem__closeIcon{color:#575766;cursor:pointer;font-size:.8rem;margin-left:1.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
